var _desc, _defs, _rect, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkKeychainGulley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 720",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Gulley Park keychains in white and black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Two Gulley Park keychains with blue lettering, a round park photo insert, and silver swivel clasps.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "metal",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8fafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8f98a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f5f7fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#6d747d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9fafb"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "parkPhoto",
    cx: "50%",
    cy: "45%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#748b59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#536f45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#b8b4a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6d8064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f4731"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "checker",
    width: 36,
    height: 36,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#eef2f6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 18,
    height: 18,
    fill: "#eef2f6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 10,
    floodColor: "#0f172a",
    floodOpacity: 0.22
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 720,
    fill: "url(#checker)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 40)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-22 245 115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 45 C142 27 100 39 81 75 L51 132 C36 161 47 197 77 212 L139 244 C171 260 209 247 224 215 L255 157 C274 122 259 64 176 45 Z",
    fill: "url(#metal)",
    stroke: "#111827",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 75 C133 64 105 73 94 96 L75 134 C65 154 73 179 94 190 L136 211 C158 222 184 213 195 191 L215 153 C226 131 216 94 156 75 Z",
    fill: "#f8fafc",
    stroke: "#111827",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 25,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 13,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 212 L42 235 C29 243 26 260 35 272 C44 285 62 287 74 278 L116 248 Z",
    fill: "url(#metal)",
    stroke: "#111827",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 210,
    r: 72,
    fill: "none",
    stroke: "url(#metal)",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 210,
    r: 44,
    fill: "none",
    stroke: "#111827",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 390,
    r: 224,
    fill: "#f8fafc",
    stroke: "#d7dde3",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 390,
    r: 155,
    fill: "url(#parkPhoto)",
    stroke: "#d1d5db",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 393 C260 340 342 333 455 367",
    fill: "none",
    stroke: "#e5e7eb",
    strokeWidth: 18,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 425 C260 391 348 389 460 420",
    fill: "none",
    stroke: "#3f513c",
    strokeWidth: 12,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontWeight: 900,
    fill: "#1688e6",
    stroke: "#0865aa",
    strokeWidth: 4,
    paintOrder: "stroke",
    letterSpacing: 7
  }, /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 292,
    transform: "rotate(-29 84 292)",
    fontSize: 70
  }, "G"), /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 253,
    transform: "rotate(-20 142 253)",
    fontSize: 70
  }, "U"), /*#__PURE__*/React.createElement("text", {
    x: 213,
    y: 229,
    transform: "rotate(-9 213 229)",
    fontSize: 70
  }, "L"), /*#__PURE__*/React.createElement("text", {
    x: 284,
    y: 224,
    transform: "rotate(4 284 224)",
    fontSize: 70
  }, "L"), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 237,
    transform: "rotate(18 350 237)",
    fontSize: 70
  }, "E"), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 275,
    transform: "rotate(31 412 275)",
    fontSize: 70
  }, "Y"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 595,
    transform: "rotate(16 130 595)",
    fontSize: 76
  }, "P"), /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 625,
    transform: "rotate(8 218 625)",
    fontSize: 76
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 312,
    y: 630,
    transform: "rotate(-4 312 630)",
    fontSize: 76
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 602,
    transform: "rotate(-17 400 602)",
    fontSize: 76
  }, "K")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(660 40)",
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-22 245 115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 45 C142 27 100 39 81 75 L51 132 C36 161 47 197 77 212 L139 244 C171 260 209 247 224 215 L255 157 C274 122 259 64 176 45 Z",
    fill: "url(#metal)",
    stroke: "#111827",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 75 C133 64 105 73 94 96 L75 134 C65 154 73 179 94 190 L136 211 C158 222 184 213 195 191 L215 153 C226 131 216 94 156 75 Z",
    fill: "#f8fafc",
    stroke: "#111827",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 25,
    fill: "#111827"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 168,
    r: 13,
    fill: "#f8fafc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 212 L42 235 C29 243 26 260 35 272 C44 285 62 287 74 278 L116 248 Z",
    fill: "url(#metal)",
    stroke: "#111827",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 210,
    r: 72,
    fill: "none",
    stroke: "url(#metal)",
    strokeWidth: 22
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 210,
    r: 44,
    fill: "none",
    stroke: "#111827",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 390,
    r: 224,
    fill: "#0c0c0c",
    stroke: "#1f2937",
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 390,
    r: 155,
    fill: "url(#parkPhoto)",
    stroke: "#111827",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 393 C260 340 342 333 455 367",
    fill: "none",
    stroke: "#e5e7eb",
    strokeWidth: 18,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183 425 C260 391 348 389 460 420",
    fill: "none",
    stroke: "#3f513c",
    strokeWidth: 12,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontWeight: 900,
    fill: "#1688e6",
    stroke: "#0865aa",
    strokeWidth: 4,
    paintOrder: "stroke",
    letterSpacing: 7
  }, /*#__PURE__*/React.createElement("text", {
    x: 84,
    y: 292,
    transform: "rotate(-29 84 292)",
    fontSize: 70
  }, "G"), /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 253,
    transform: "rotate(-20 142 253)",
    fontSize: 70
  }, "U"), /*#__PURE__*/React.createElement("text", {
    x: 213,
    y: 229,
    transform: "rotate(-9 213 229)",
    fontSize: 70
  }, "L"), /*#__PURE__*/React.createElement("text", {
    x: 284,
    y: 224,
    transform: "rotate(4 284 224)",
    fontSize: 70
  }, "L"), /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 237,
    transform: "rotate(18 350 237)",
    fontSize: 70
  }, "E"), /*#__PURE__*/React.createElement("text", {
    x: 412,
    y: 275,
    transform: "rotate(31 412 275)",
    fontSize: 70
  }, "Y"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 595,
    transform: "rotate(16 130 595)",
    fontSize: 76
  }, "P"), /*#__PURE__*/React.createElement("text", {
    x: 218,
    y: 625,
    transform: "rotate(8 218 625)",
    fontSize: 76
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 312,
    y: 630,
    transform: "rotate(-4 312 630)",
    fontSize: 76
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 602,
    transform: "rotate(-17 400 602)",
    fontSize: 76
  }, "K")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkKeychainGulley);
export default __webpack_public_path__ + "static/media/park_keychain_gulley.9ca7d326aeb7009b4e7ee27c256025fc.svg";
export { ForwardRef as ReactComponent };